// import { API_DOMAIN_DEFAULT } from '../../model/model';
// import { BoardName } from './Model';
import { truthy, falsy, parseInt10, getUriParams } from '../../utils/util';


class Utils {

	static get ServerMasterBoard(){
		let isServerMasterBoard;
		let locationParams = getUriParams(document.location.href) || {};
		isServerMasterBoard = ( locationParams.metaTags && locationParams.metaTags == 'servermaster') ? true : false;
		return isServerMasterBoard;
	}

	static get getServerAlias(){
		let ServerAlias;
		ServerAlias = window.userData.gameAccount.serverId || 1;
		return ServerAlias;
	}

	static HookSubmitBefore(data) {

		if(serverWrite) serverWrite.submitWriteData(data);
		console.log('Utils.js > HookSubmitBefore: ', data);

	}


	static HookWriteBefore() {

		const _board = window._boardConfig.board;

		function isBBSBanned() { // 글쓰기 제재 상태 체크
			let BBSBannedStatus;
			$.ajax({
				type: 'GET',
				url: window._communityApiPath +'board/writer/is-bbs-banned',
				async: false,
				dataType: 'json',
				contentType: 'application/json',
				xhrFields: {withCredentials: true},
				success: function (data) {
					if (data) {
						BBSBannedStatus = true;
					} else {
						BBSBannedStatus = false;
					}
				},
				error: function (data) {
					window.alert('잠시 후, 다시 시도해주세요.');
				}
			});
			return BBSBannedStatus;
		}

		function checkBoardLevel() { // 글쓰기 레벨 체크
			let boardLevel;
			const _categoryId = $('.selectedCategory').attr('data-value') || $('[name="board-category"] option:selected').val() || $(".scroll-category .category-items.is-active").data('value') || window._boardConfig.categoryId || ``; // 5ec50d7c82915c0001ace1f1
			console.log('Utils checkBoardLevel , check is bbs writable _categoryId : ', _categoryId, window._boardConfig);


			$.ajax({
				type: 'GET',
				// url: window._path+'board/writer/'+_board+'/character-level',
				url: window._communityApiPath +'board/writer/is-bbs-writable?boardAlias='+ _board + '&categoryId='+ _categoryId,
				async:false,
				// dataType: 'json',
				contentType: 'application/json',
				xhrFields: {withCredentials: true},
				success: function() {
					boardLevel = true;
					// console.log('Utils.js > HookWriteBefore checkBoardLevel success data/boardLevel : ', data, boardLevel );
					// return boardLevel = true;
				},
				error: function(data) {
					boardLevel = false;
					// console.log('Utils.js > HookWriteBefore checkBoardLevel error data/boardLevel : ', data, boardLevel);
					alert(data.responseJSON.result.message); // 얼럿이 두번 떠서 이거 제거함
					// return boardLevel = false;
				}
			});
			return boardLevel;
		}



		if (!userData.isLogin) {
			GNBLogin();
			return false; //false 리턴 시 write 페이지로 이동하지 않음
		} else {

			let _isBbsBanned = isBBSBanned();
			let _isBbsWritable = checkBoardLevel();

			var caseNum = '';
			if (userData.accountState.length > 0) caseNum = userData.accountState[userData.accountState.length - 1].case;

			if(! _isBbsWritable) {
				return false;
			}
			if (_isBbsBanned || caseNum == '7' || caseNum == '8' || caseNum == '9') {
				alert('제재된 계정입니다. 자세한 사항은 고객센터로 문의해 주세요.');
				return false;
			} else if (caseNum == '2') {
				alert('본인확인이 필요합니다.');
				return false;
			} else if (caseNum == '3' || userData.gameAccount.name == null || userData.gameAccount.name == '') {
				alert('서비스 이용을 위해 대표 캐릭터를 선택해 주세요.');
				return false;
			} else {
				return true; //true 리턴 시 write 페이지로 이동
			}
		}

		console.log('_isBbsBanned , _isBbsWritable : ', _isBbsBanned , _isBbsWritable );
	}

}


export default Utils;




// WEBPACK FOOTER //
// ./_src/js/board/config/Util.js